import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { Observable, tap } from 'rxjs';
import { Notification } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notifications:Notification[] = [];
  constructor(
    public http : AppHttpClient
  ) { }

  getNotifications():Observable<Notification[]>{
    return this.http.get('notification').pipe(
      tap((res:any)=>{
        this.notifications = res.map((notification:any)=>new Notification(notification));
      })
    );
  }

  isOutage(){
    return this.notifications.find(i=>i.type == "Outage");
  }
}
